import { render, staticRenderFns } from "./AcknowledgeButton.vue?vue&type=template&id=dd1faf9c&scoped=true"
import script from "./AcknowledgeButton.vue?vue&type=script&lang=js"
export * from "./AcknowledgeButton.vue?vue&type=script&lang=js"
import style0 from "./AcknowledgeButton.vue?vue&type=style&index=0&id=dd1faf9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1faf9c",
  null
  
)

export default component.exports